import {type MouseEvent} from 'react'
import {DropdownItem} from 'swayok-react-mdb-ui-kit/components/Dropdown/DropdownItem'
import {
    Icon,
    type IconProps,
} from 'swayok-react-mdb-ui-kit/components/Icon/Icon'

interface Props {
    icon: IconProps['path']
    title: string
    onClick: (event: MouseEvent<HTMLElement>) => void
    disabled?: boolean
}

// Пункт меню для выпадающего меню действий чата.
export function ChatActionsDropdownItem(props: Props) {

    const {
        icon,
        title,
        disabled,
        onClick,
    } = props

    return (
        <DropdownItem
            className="d-flex align-items-center justify-content-between gap-3"
            disabled={disabled}
            onClick={event => {
                // Отключить стандартную обработку события
                // и предотвратить передачу события родительскому элементу.
                // Если этого не сделать, то совершится переход к сообщениям чата.
                event.preventDefault()
                event.stopPropagation()
                // Вызвать обработчик клика на пункте меню.
                onClick(event)
            }}
        >
            {title}
            <Icon
                path={icon}
                color="body"
                size={20}
            />
        </DropdownItem>
    )
}
